function map(value, minA, maxA, minB, maxB, clamped = false) {
    if (clamped) value = Math.min(maxA, Math.max(minA, value));
    return ((value - minA) / (maxA - minA)) * (maxB - minB) + minB;
}

function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

function lerp(min, max, t) {
    return min * (1 - t) + max * t;
}

function mod(a, b) {
    return ((a % b) + b) % b;
}

module.exports = {
    lerp,
    clamp,
    map,
    mod,
};
